import React, { FC } from 'react';
import { ExclamationCircle } from '@platzi/icons';
import { Button } from '@/components/shared';
import styles from './GlobalError.module.sass';

interface GlobalErrorProps { onRetry: () => void };

export const GlobalError: FC<GlobalErrorProps> = ({ onRetry }) => {
  return (
    <section className={styles.GlobalError}>
      <ExclamationCircle />
      <h4 className={styles.GlobalError__title}>Hubo un error al cargar el contenido</h4>
      <p className={styles.GlobalError__info}>
        Intenta recargar y si el problema continua escríbenos a team@platzi.com
      </p>
      <Button onClick={onRetry}>Recargar</Button>
    </section>
  );
};
